import {Injectable} from "@angular/core";
import {HttpClient, HttpHeaders} from '@angular/common/http';
import {AppSettings} from "../../config/config";
import {map} from 'rxjs/operators';

@Injectable()
export class StudentTransportSettingsService {

  private _url = AppSettings.API_ENDPOINT;
  constructor(private http: HttpClient) {
  }


  fetchBusStop(AUTHTOKEN,current_academic){
    const params = {current_academic:current_academic};
    const headers = new HttpHeaders().append('Content-Type', 'application/json').append('authToken', AUTHTOKEN);
    return this.http.post(this._url + '/bus/getBusStopsList',
      params, {headers:headers})
      .pipe(map(res => res));
  }

  getBusListForStop(stopId,AUTHTOKEN,current_academic){
    const params = {stopId:stopId,current_academic:current_academic};
    const headers = new HttpHeaders().append('Content-Type', 'application/json').append('authToken', AUTHTOKEN);
    return this.http.post(this._url + '/bus/getBusListFoStop',
      params, {headers:headers})
      .pipe(map(res => res));
  }

  getStudentTermsDetail(studentId,AUTHTOKEN,current_academic){
    const params = {studentId:studentId,current_academic:current_academic};
    const headers = new HttpHeaders().append('Content-Type', 'application/json').append('authToken', AUTHTOKEN);
    return this.http.post(this._url + '/bus/getbustermsforstudent',
      params, {headers:headers})
      .pipe(map(res => res));
  }

  //update student details
  updateStudentDetails(transportOptions, AUTHTOKEN) {
    const params = transportOptions;
    const headers = new HttpHeaders().append('Content-Type', 'application/json').append('authToken', AUTHTOKEN);
    return this.http.post(this._url + '/addstudent/updateStudent/transport',
      params, {headers: headers})
      .pipe(map(res => res));
  }
}
